import type { InputHTMLAttributes } from 'react';
import { Icon } from '@/components/foundations';

export type SearchInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & { label: string };

/** Busca dos filtros (`.input` com lupa). `label` vira `aria-label`. */
export function SearchInput({ label, ...input }: SearchInputProps) {
  return (
    <div className="input">
      <Icon name="search" />
      <input aria-label={label} {...input} />
    </div>
  );
}
